var VendorCategory;

jQuery(function ($) {
    VendorCategory = {

        faqLastFocused: 0,
        initFaq: function () {
            const $this = this;

            jQuery(document).on('click', '#faq_holder .question', function () {
                const time = Math.floor((new Date()).getTime() / 1000);
                if ($this.faqLastFocused === time) {
                    return;
                }
                jQuery(this).parent('.single-qa').toggleClass('active');
            });

            jQuery('#faq #faq_holder .single-qa').on('focus', function () {
                const self = jQuery(this);
                if (!self.hasClass('active')) {
                    self.addClass('active');
                    $this.faqLastFocused = Math.floor((new Date()).getTime() / 1000);
                }
            });
        },

        initPopularReadersSlider: function () {
            const $readersCarouselHolder = jQuery('.popular-readers-items.mobile');
            const isCompacted = $readersCarouselHolder.hasClass('compacted');

            if ($readersCarouselHolder.find('.popular-reader-item').length < 2) {
                return false;
            }

            let slickInitialized = false;

            jQuery(window).on('resize', function () {
                if (Device.isMobile() || (isCompacted && Device.isTablet())) {
                    if (!slickInitialized) {
                        let params;
                        if (isCompacted) {
                            params = {
                                prevArrow: '<a href="#" class="slick-prev" aria-label="Previous slide"></a>',
                                nextArrow: '<a href="#" class="slick-next" aria-label="Next slide"></a>',
                                initialSlide: 0,
                                dots: true,
                                centerMode: true,
                                centerPadding: '32px',
                                slidesToShow: 1
                            };
                        } else {
                            params = {
                                prevArrow: '<a href="#" class="slick-prev" aria-label="Previous slide"></a>',
                                nextArrow: '<a href="#" class="slick-next" aria-label="Next slide"></a>',
                                initialSlide: 0
                            };
                        }

                        $readersCarouselHolder.find('.readers-carousel').slick(params);

                        slickInitialized = true;
                    } else {
                        $readersCarouselHolder.find('.readers-carousel').slick('resize');
                    }
                } else {
                    if (slickInitialized) {
                        slickInitialized = false;
                        $readersCarouselHolder.find('.readers-carousel').slick('unslick');
                    }
                }

            });
        },

        initBestReadingSlider: function () {
            var $carouselHolder = jQuery('.best-reading-box');

            if ($carouselHolder.find('.best-reading-item').length < 2) {
                return false;
            }

            var slickInitialized = false;

            jQuery(window).on('resize', function () {
                if (Device.isMobile()) {
                    if (!slickInitialized) {
                        $carouselHolder.find('.readers-carousel').slick({
                            prevArrow: '<a href="#" class="slick-prev" aria-label="Previous slide"></a>',
                            nextArrow: '<a href="#" class="slick-next" aria-label="Next slide"></a>',
                            initialSlide: 1,
                            dots: true,
                            centerMode: true,
                            centerPadding: '32px',
                            slidesToShow: 1
                        });

                        slickInitialized = true;
                    } else {
                        $carouselHolder.find('.readers-carousel').slick('resize');
                    }
                } else {
                    if (slickInitialized) {
                        slickInitialized = false;
                        $carouselHolder.find('.readers-carousel').slick('unslick');
                    }
                }

            });
        },

        initPodiumSlider: function () {
            var $podiumCarouselHolder = jQuery('.ppc-podium');

            if (!$podiumCarouselHolder || $podiumCarouselHolder.find('.ppc-podium-item').length < 2) {
                return false;
            }

            var slickInitialized = false;

            jQuery(window).on('resize', function () {
                if (Device.isMobile()) {
                    if (!slickInitialized) {
                        $podiumCarouselHolder.find('.podium-carousel').slick({
                            prevArrow: false,
                            nextArrow: false,
                            initialSlide: 0,
                            variableWidth: true
                        });

                        slickInitialized = true;
                    } else {
                        $podiumCarouselHolder.find('.podium-carousel').slick('resize');
                    }
                } else {
                    if (slickInitialized) {
                        slickInitialized = false;
                        $podiumCarouselHolder.find('.podium-carousel').slick('unslick');
                    }
                }

            });
        },

        initMobileScrollbox: function () {
            let isHidden = false;
            jQuery(window).on('scroll', function () {
                if (isHidden) {
                    return;
                }

                let scrollbox = jQuery('#mobile_ppc_scrollbox'),
                    showFrom = jQuery('.best-kit-block.single-vendor').offset().top + jQuery('.best-kit-block.single-vendor').outerHeight() - 60,
                    scrollTop = jQuery(document).scrollTop();

                if (scrollbox.hasClass('hidden') && showFrom < scrollTop) {
                    scrollbox.removeClass('hidden');
                }

                if (showFrom > scrollTop && !scrollbox.hasClass('hidden')) {
                    scrollbox.addClass('hidden');
                }
            });

            jQuery('#scroll_close').click(function (e) {
                e.preventDefault();
                jQuery('#mobile_ppc_scrollbox').addClass('hidden');
                isHidden = true;
            });
        },

        initDesktopScrollbox: function () {
            jQuery(window).on('scroll', function () {
                var scrollbox = jQuery('#desktop_scrollbox'),
                    showFrom = jQuery('.vendor-category-page-top').offset().top + jQuery('.vendor-category-page-top').outerHeight() - 15,
                    scrollTop = jQuery(document).scrollTop();

                if (jQuery('#categories_menu')) {
                    showFrom += jQuery('#categories_menu').outerHeight();
                }

                if (scrollbox.hasClass('hidden') && showFrom < scrollTop) {
                    scrollbox.removeClass('hidden');
                    jQuery('#quick-nav').addClass('top-space');
                }

                if (showFrom > scrollTop && !scrollbox.hasClass('hidden')) {
                    scrollbox.addClass('hidden');
                    jQuery('#quick-nav').removeClass('top-space');
                }
            });
        },

        initDetailsToggle: function () {
            $('.details-toggle').click(function (e) {
                e.preventDefault();
                $(this).closest('.single-vendor').toggleClass('hide-details-mobile');
            });
        },

        initSocialProof: function () {
            setTimeout(function () {
                let item = jQuery('.social-proof');
                if (item.hasClass('hidden')) {
                    item.removeClass('hidden');
                }
            }, 1000);
        },

        initWrappedText: function () {
            jQuery('.wrapped-text').each(function (i, item) {
                jQuery(item).find('.read-more').click(function (e) {
                    e.preventDefault();
                    item.classList.add('wrapped');
                });

                jQuery(item).find('.read-less').click(function (e) {
                    e.preventDefault();
                    item.classList.remove('wrapped');
                });
            });
        },

        initReadMore: function () {
            jQuery('.read-more-btn').click((e) => {
                e.preventDefault();
                jQuery(e.target).closest('.vendor-item-body').toggleClass('and-more');
            });

            jQuery('.more-btn').click((e) => {
                e.preventDefault();
                jQuery(e.target).closest('.vendor-bullets').toggleClass('opened');
            });
        },

        inactiveDisappearingTooltipsVendors: [],
        showTooltip: function ($tooltipElement) {
            const vendor = $tooltipElement.data('vendorId');
            if (!vendor || this.inactiveDisappearingTooltipsVendors.indexOf(vendor) !== -1) {
                return;
            }

            this.inactiveDisappearingTooltipsVendors.push(vendor);

            $tooltipElement.addClass('visible');
            setTimeout(() => {
                $tooltipElement.removeClass('visible');
            }, 1800);
        },
        initDisappearingTooltips: function () {
            const tooltips = jQuery('.disappearing-tooltip');
            if (!tooltips.length) {
                return;
            }

            const observerCallback = (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        this.showTooltip(jQuery(entry.target.querySelector('.disappearing-tooltip')));
                    }
                }
            };
            const observer = new IntersectionObserver(observerCallback, {
                root: null,
                threshold: 1.0,
            });

            jQuery('#vendors_list .single-vendor').each((i, element) => {
                if (i < 3) {
                    observer.observe(element);
                }
            });
        },

        init: function () {
            var self = this;

            self.initDisappearingTooltips();
            self.initFaq();
            self.initDetailsToggle();
            self.initPopularReadersSlider();
            self.initBestReadingSlider();
            self.initPodiumSlider();
            jQuery(window).resize();

            if (Device.isMobile()) {
                self.initMobileScrollbox();
            } else {
                self.initDesktopScrollbox();
            }

            self.initSocialProof();
            self.initWrappedText();
            self.initReadMore();
        }
    };

    VendorCategory.init();
});
